module.exports = "attribute vec3 computedNormal;\n\nvarying vec3 f_normal;\nvarying vec3 f_position;\n\n// uv, position, projectionMatrix, modelViewMatrix, normal\nvoid main() {\n    f_normal = computedNormal;\n    f_position = position;\n    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n}"


//////////////////
// WEBPACK FOOTER
// ./src/glsl/lambert-vert.glsl
// module id = 12
// module chunks = 0